import React from 'react';

import ReactTable from 'react-table';

import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import AutoRenew from '@material-ui/icons/Autorenew';
import Send from '@material-ui/icons/Send';

// core components
import Card from 'components/Card';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardBody from 'components/Card/CardBody.jsx';

import regularFormsStyle from 'assets/jss/omni/views/regularFormsStyle';

import { cardTitle, tooltip } from 'assets/jss/omni.jsx';

import {
  getNotificadorTemplates,
} from 'providers/api-rest.js';

const styles = {
  tooltip,
  regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  updateTable: {
    position: 'absolute',
    top: '10px',
    padding: 0,
    margin: 0,
    width: '30%'
  },
  updatedCursor: {
    cursor: 'pointer'
  }
};

class ListTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentWillReceiveProps = props => {
    if (props.newtemplate) {
      this.onFetchDataReload();
    }
  };

  async onFetchData(state) {
    this.setState({ loading: true });
    const response = await getNotificadorTemplates();
    this.setState({
      data: response.data ? response.data : [],
      loading: false,
      pages: response.data ? response.data.pages : 1
    });
  }

  onFetchDataReload() {
    this.setState({ loading: true });
    this.onFetchData(this.state.lastState);
  }

  render() {
    const { classes } = this.props;
    const columns = [
      {
        Header: 'identificador',
        accessor: 'id',
        minWidth: 150
      },
      {
        Header: 'Titulo',
        accessor: 'subject',
        minWidth: 150
      },
      {
        Header: 'Cuerpo',
        accessor: 'message',
        minWidth: 400
      }
    ];
    return (
      <Card>
        <CardHeader color='primary' icon>
          <CardIcon color='primary'>
            <Send />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            Plantillas de Notificaciones Push
            <span
              className={classes.updatedCursor}
              onClick={() => this.onFetchDataReload()}
            >
              <strong> |</strong> Actualizar
              <span className={classes.updateTable}>
                <AutoRenew />
              </span>
            </span>
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            manual
            data={this.state.data}
            columns={columns}
            defaultPageSize={6}
            loading={this.state.loading}
            filterable={false}
            sortable={false}
            showPagination={false}
            onFetchData={state => this.onFetchData(state)}
            className='-cards -highlight'
            noDataText='No se han encontrado resultados'
            showPageSizeOptions={false}
          />
        </CardBody>
      </Card>
    );
  }
}

ListTemplates.propTypes = {
  classes: PropTypes.object.isRequired,
  newtemplate: PropTypes.bool
};

export default withStyles(styles)(ListTemplates);
